import { render, staticRenderFns } from "./WeblogDetails.vue?vue&type=template&id=f57356a8&scoped=true"
import script from "./WeblogDetails.vue?vue&type=script&lang=js"
export * from "./WeblogDetails.vue?vue&type=script&lang=js"
import style0 from "./WeblogDetails.vue?vue&type=style&index=0&id=f57356a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f57356a8",
  null
  
)

export default component.exports